<template>
	<section id="home">

			<v-container class="fill-height px-4 py-12">
				<v-responsive
					class="d-flex align-center"
					height="100%"
					width="100%"
				>
					<v-row align="center" justify="center">
						<v-col cols="12" sm="8">
							<h1>DigiKoli - Kollégiumi Adminisztrációs Rendszer</h1>

		            A DigiKoli egy kollégiumi adminisztrációs rendszer, amely nyilvántartja a kollégista tanulókat, minősítéseiket, csoportjaikat, szakköri jelenlétüket havi szinten, a szobarendjük pontozását napi szinten, melyből látványos kimutatást készíthet. Ezenkívül még naplózza a ki- és belépéseket, valamint nyilvántartja, hogy ki melyik szilenciumon szeretne tanulni.

							<div
								:class="$vuetify.breakpoint.smAndDown ? 'flex-column align-start' : 'align-center'"
								class="d-flex flex-wrap"
							>
								<router-link  v-if="!$store.state.bejelentkezve" :to="{name: 'bejelentkezes'}">
									<v-btn
										:ripple="false"
										color="primary"
										rounded
									>
										Bejelentkezés
									</v-btn>
								</router-link>
								<router-link  v-else :to="{name: 'profil'}">
									<v-btn
										:ripple="false"
										color="primary"
										rounded
									>
										Tovább a szoftverre
									</v-btn>
								</router-link>
							</div>
						</v-col>
						<v-col cols="12" sm="4">
							<v-img
				        :src="`${$store.state.backendeleres}dynamic/logo.png`"
				      />
						</v-col>
					</v-row>
				</v-responsive>
			</v-container>
	</section>
</template>

<script>
export default {
	computed: {
		minHeight () {
			const height = this.$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'

			return `calc(${height} - ${this.$vuetify.application.top}px)`
		},
	},
}
</script>
